var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "login", staticClass: "login" },
    [
      _c(
        "a-dropdown",
        [
          _c(
            "a",
            {
              staticClass: "language-box",
              on: { click: (e) => e.preventDefault() },
            },
            [
              _c("icon-font", { attrs: { type: "gb-icon-Language" } }),
              _vm._v(
                " " + _vm._s(_vm.languageCodes[_vm.currentLang].label) + " "
              ),
              _c("a-icon", { attrs: { type: "down" } }),
            ],
            1
          ),
          _c(
            "a-menu",
            {
              attrs: { slot: "overlay", selectedKeys: [_vm.currentLang] },
              on: { click: _vm.changeLang },
              slot: "overlay",
            },
            _vm._l(Object.keys(_vm.languageCodes), function (locale) {
              return _c("a-menu-item", { key: locale }, [
                _c(
                  "span",
                  {
                    staticStyle: { "margin-right": "4px" },
                    attrs: {
                      role: "img",
                      "aria-label": _vm.languageCodes[locale].label,
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.languageCodes[locale].flag) + " ")]
                ),
                _vm._v(" " + _vm._s(_vm.languageCodes[locale].label) + " "),
              ])
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "login-swiper" },
        [
          _vm._l(_vm.swiperList, function (item, index) {
            return _c("div", {
              key: index,
              staticClass: "login-swiper-item",
              class: {
                cur: index === _vm.swiperCurrent,
                cursor: item.jumpUrl ? true : false,
              },
              style: {
                background: `url(${(
                  item["bannerUrl" + _vm.codes[_vm.currentLang]] ||
                  item["bannerUrl"] ||
                  ""
                ).replace(
                  "eccang-ess.oss-cn-shenzhen.aliyuncs.com",
                  "file.eccang.com"
                )}) no-repeat ${
                  _vm.currentLang === "zh_CN" ? "center" : "left"
                } top /cover`,
              },
              on: {
                click: function ($event) {
                  return _vm.bannerTo(item)
                },
              },
            })
          }),
          _vm.swiperList.length > 1
            ? _c(
                "div",
                { staticClass: "login-swiper-pagination" },
                _vm._l(_vm.swiperList, function (bool, index) {
                  return _c("div", {
                    key: index,
                    staticClass: "login-swiper-pagination__bool",
                    class: { cur: index === _vm.swiperCurrent },
                    on: {
                      click: function ($event) {
                        return _vm.swiperTo(index)
                      },
                    },
                  })
                }),
                0
              )
            : _vm._e(),
        ],
        2
      ),
      _c("div", { staticClass: "login-main" }, [
        _c(
          "section",
          [
            _c(
              "div",
              { staticClass: "login-main-logo" },
              [
                _c("icon-font", {
                  staticStyle: { "font-size": "180px" },
                  attrs: { type: "gb-icon-yicangxinlogo" },
                }),
              ],
              1
            ),
            /^back/.test(_vm.comp)
              ? _c(
                  "div",
                  { staticClass: "login-main-title" },
                  _vm._l(_vm.backTabs, function (tab) {
                    return _c(
                      "a-button",
                      {
                        key: tab.value,
                        style: {
                          color: _vm.comp === tab.value ? "#1C2D42" : "#7F93A8",
                        },
                        attrs: { type: "link" },
                        on: {
                          click: function ($event) {
                            _vm.comp = tab.value
                          },
                        },
                      },
                      [_vm._v(_vm._s(tab.label))]
                    )
                  }),
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "login-main-title",
                    style:
                      _vm.titleFormat.length === 2
                        ? { "letter-spacing": "8px" }
                        : {},
                  },
                  [_vm._v(" " + _vm._s(_vm.titleFormat) + " ")]
                ),
            _vm.$route.path === "/oauth/login"
              ? _c("auth-form", {
                  on: { agreement: (type) => (this[type] = true) },
                })
              : _vm.comp === "login"
              ? _c("login-form", {
                  on: {
                    to: _vm.to,
                    agreement: (type) => (this[type] = true),
                    done: _vm.routeToMode,
                  },
                })
              : _vm.comp === "register"
              ? _c("register-form", {
                  on: {
                    to: _vm.to,
                    agreement: (type) => (this[type] = true),
                    done: _vm.routeToMode,
                  },
                })
              : _vm.comp === "bind"
              ? _c("bind-form", {
                  on: {
                    to: _vm.to,
                    agreement: (type) => (this[type] = true),
                    done: _vm.routeToMode,
                  },
                })
              : /^back/.test(_vm.comp)
              ? _c("back-password-form", {
                  attrs: { comp: _vm.comp },
                  on: {
                    to: _vm.to,
                    agreement: (type) => (this[type] = true),
                    done: _vm.routeToMode,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("agreement-modal", {
        attrs: { visible: _vm.agreementVisible },
        on: {
          ok: function ($event) {
            _vm.agreementVisible = false
          },
        },
      }),
      _c("policy-modal", {
        attrs: { visible: _vm.policyVisible },
        on: {
          ok: function ($event) {
            _vm.policyVisible = false
          },
        },
      }),
      _c(
        "div",
        { staticClass: "weChat-wrapper", class: [_vm.isWxQrCode && "show"] },
        [
          _c("div", { staticClass: "ball1" }),
          _c("div", { staticClass: "ball2" }),
          _c("qr-code", {
            attrs: { show: _vm.isWxQrCode },
            on: {
              to: _vm.to,
              "update:show": function ($event) {
                _vm.isWxQrCode = $event
              },
              done: _vm.routeToMode,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }